import React from "react";
import { Link } from "react-router-dom";

function Home() {
  const operationCards = [
    { to: "/TransactionsAdd", title: "Enter Transaction", desc: "Capture a transaction for the current working entity" },
    { to: "/Transactions", title: "Review Transactions", desc: "Filter, inspect, and edit recorded transactions" },
    { to: "/AssetsAdd", title: "Enter Asset", desc: "Record a new asset and current valuation" },
    { to: "/Assets", title: "Review Assets", desc: "Update asset values and valuation dates" },
  ];

  const reportCards = [
    { to: "/ReportsDashboard", title: "Dashboard", desc: "View key financial summary metrics in one place" },
    { to: "/ReportsPassiveIncome", title: "Passive Income", desc: "Estimate annual and monthly interest income from bank balances" },
    { to: "/ReportsPassiveIncomeTracking", title: "Passive Income Tracking", desc: "Track passive income by period in a line chart" },
    { to: "/ReportsNetWorth", title: "Net Worth Report", desc: "Visualize net worth by reporting period over time" },
    { to: "/NetWorth", title: "Net Worth", desc: "Store and recompute net worth values by period" },
    { to: "/ReportsIncomeExpenditureTracking", title: "Income, Expenditure Tracking", desc: "Track income, debits excluding savings, savings, and passive income over time" },
    { to: "/ReportsIncomeTrends", title: "Income Trends", desc: "See how each income category moves across reporting periods" },
    { to: "/ReportsPeriodSummary", title: "Period Summary", desc: "Review credits, debits, and category expenditure by period" },
    { to: "/ReportsSpendingTrends", title: "Spending Trends", desc: "See how each spending category moves across reporting periods" },
    { to: "/ReportsPeriodTransactions", title: "Period Transaction Summary", desc: "Inspect category activity for a selected reporting period" },
  ];

  const referenceCards = [
    { to: "/Banks", title: "Banks", desc: "Accounts, balances, and interest rates" },
    { to: "/Loans", title: "Loans", desc: "Loan records, lenders, and running liability balances" },
    { to: "/Periods", title: "Periods", desc: "Reporting windows used by transactions and net worth" },
    { to: "/Currencies", title: "Currencies", desc: "Exchange rates into the default currency" },
    { to: "/Categories", title: "Categories", desc: "Income, expenditure, and savings groupings" },
    { to: "/Subcategories", title: "Subcategories", desc: "Detailed transaction tagging under categories" },
    { to: "/TransactionTypes", title: "Transaction Types", desc: "Credit and debit behavior definitions" },
    { to: "/Settings", title: "Settings", desc: "Profile and current entity context" },
    { to: "/Entities", title: "Entities", desc: "Administer entities and access rights" },
    { to: "/GettingStarted", title: "Getting Started", desc: "Suggested setup procedure for a new user or entity" },
  ];

  return (
    <div className="page">
      <section className="panel">
        <div className="section-heading">
          <div>
            <p className="eyebrow">Workflows</p>
          </div>
        </div>
        <div className="dashboard-grid">
          {operationCards.map((card) => (
            <Link key={card.to} to={card.to} className="nav-card nav-card-primary">
              {card.title}
              <small>{card.desc}</small>
            </Link>
          ))}
        </div>
      </section>

      <section className="panel page-cta">
        <div className="section-heading">
          <div>
            <p className="eyebrow">Reports</p>
          </div>
        </div>
        <div className="dashboard-grid">
          {reportCards.map((card) => (
            <Link key={card.to} to={card.to} className="nav-card">
              {card.title}
              <small>{card.desc}</small>
            </Link>
          ))}
        </div>
      </section>

      <section className="panel page-cta">
        <div className="section-heading">
          <div>
            <p className="eyebrow">Reference</p>
          </div>
        </div>
        <div className="dashboard-grid">
          {referenceCards.map((card) => (
            <Link key={card.to} to={card.to} className="nav-card">
              {card.title}
              <small>{card.desc}</small>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;
